import React from 'react';
const noMore = ['No more hours rebuilding lessons.', 'No more searching for random drills.', 'No more explaining visual underwater skills only with words.', 'No more disconnected teaching ideas.', 'No more wondering what students should practice next.', 'No more recreating the same corrections repeatedly.', 'No more beginning every lesson from an empty page.'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-navy relative overflow-hidden" data-id="element-105" data-mp="m3nhjvncs0p0">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-106" data-mp="h6dlvy9dessq">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-white uppercase" data-id="element-107" data-mp="h413jjzpagf5">
          Next Week You Can Keep Planning Every Scuba Lesson From Scratch...
          <br data-id="element-108" data-mp="qxrqgkg6iisq" />
          <span className="text-cta" data-id="element-109" data-mp="qy17hij8xfma">
            Or You Can Open a Complete Teaching System and Already Know Where to Start.
          </span>
        </h2>
        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/5 p-8 rounded-2xl border border-white/15" data-id="element-110" data-mp="zxo7bzwbudd8">
          {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-111" data-mp="2h3hoqp2m8y6d">
              <span className="text-aqua mt-0.5" aria-hidden="true" data-id="element-112" data-mp="2h3zt68zfmipd">
                ▸
              </span>
              <span className="text-white/85" data-id="element-113" data-mp="2m4xaykgj5aqc">{item}</span>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-114" data-mp="2qzujlq9wdi2p">
          Scuba Diving Instructor Ready Does Not Replace Your Experience.
        </p>
        <p className="text-xl text-white/80 mb-6" data-id="element-115" data-mp="301k8aocea2ws">
          It gives you a system for using that experience with greater:
        </p>
        <p className="text-lg md:text-2xl font-extrabold tracking-widest text-cta" data-id="element-116" data-mp="34vf0kg62fq7h">
          STRUCTURE · CLARITY · CONSISTENCY · EFFICIENCY
        </p>
      </div>
    </section>;
}